import React from 'react';
import styles from './OrangeInfoBanner.module.scss';

export const BannerType = {
  VEHICLE_REMINDERS_BANNER: 'VEHICLE_REMINDERS_BANNER',
};

const OrangeInfoBanner = ({ title, text, type }) => (
  <div className={`${styles.wrapper} ${type === BannerType.VEHICLE_REMINDERS_BANNER ? styles.vehicleRemindersPageInfo : ''}`}>
    <p className={styles.title}>{title}</p>
    <p>{text}</p>
  </div>
);

export default OrangeInfoBanner;
